import AOS from 'aos';

export default function initAOS() {
  if (!Shopify.designMode) {
    AOS.init({ duration: 1200, offset: 24 });
  }
}
